import React,{useState,useEffect} from 'react';
import queryString from 'query-string';
import {instance,comma,phoneFormat} from './common';
import Bottom_menu from './Bottom_menu';
import { Container, Row, Col } from 'react-bootstrap';
import TopTitle from './TopTitle';


function totalPrice(data) {
    let price = 0;
    data.forEach(function (v) {
      if(v.is_check == 1){
        price += Number(v.daeri_price) * v.pr_count;
      }
    });
    return comma(price);
  }

  

function OrderPage({history,location}){

    const query = queryString.parse(location.search);
    let session = JSON.parse(window.sessionStorage.result);
    let { u_type, u_id, u_sigong,u_login_id } = session;

    let status = query.status;
    let o_id = query.o_id;
    const [data, setData] = useState([]);
    const [myData, setMyData] = useState([]);

    useEffect(() => {


        const fetchData = async () => {

            instance.post('/purchase/number', {p_number:o_id}).then(function (res) {    
                    console.log('data :', res.data)
                    setData(JSON.parse(res.data[0].p_pr_id));
            });
            instance.post('/sigong/id', {si_id:u_sigong}).then(function (res) {setMyData(res.data);});
      
        };
      
        fetchData();
    
      }, []);


      
  const wordBreak = {
    wordBreak: 'keep-all'
  }
  const w60 = {
    width: '60%',
    verticalAlign: 'top'
  }
  const w30 = {
    width: '40%'
  }

  const moreCss = {
    width: '35px'
  }


  const bgSet = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '30%',
    height: '80px',
    borderRadius: '5px',
    display: 'inline-block',
    border:'1px solid #ddd'
  }

  const ab = {
    position: 'absolute',
    right: '-4px',
    top: '14px',
    color: 'lightgray',
    fontSize: '10px'
  }
  const traswi = {
    width: '25px'
  }

    return (
        <>
         <Container className="mb-5" style={{paddingBottom:'100px'}}>
        <div className="c_pad">
          <TopTitle title="주문 확인" />
          <div className="row p-0">
            {
              data.map(v => v.is_check == 1 && <div className="col-12 pt-4 pb-3 pl-0 pr-0" key={v.s_id} data-id={v.s_id} style={{ position: 'relative' }}>   
                <div className="" data-id={v.pr_id}>
                  <div data-id={v.pr_id} style={{ ...bgSet, backgroundImage: 'url(\'' + v.pr_img + '\')' }}></div><div data-id={v.pr_id} className="d-inline-block" style={{ ...wordBreak, verticalAlign: 'top' ,width:'70%'}}>
                    <h4 className="text-primary font-weight-bold ml-3" data-id={v.pr_id} style={{ width: '160px' }}>{v.pr_name}</h4>
                    <div data-id={v.pr_id} style={{ marginTop: '15px' }}>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3"> 수량 : {v.pr_count} 개</h4>
                      <h4 data-id={v.pr_id} className="font-weight-bold ml-3 text-primary">{comma(v.daeri_price * v.pr_count)} 원</h4>
                    </div>
                  </div>
                </div>
              </div>)
            }

          </div>
          <div className="row pl-0 pr-0 pt-0 mt-5 mb-5">
                <div className="border-dark d-block w-100" style={{ borderBottom: '2px solid black' }}>
                    <h3 className="font-weight-bold">주문자 정보</h3>
                </div>
                {
                    myData.map(v => 
                        <div className="w-100">
                            <div className="mt-4">
                                <label style={{width:'85px'}}>시공지점</label>
                                <span name="si_name" type="text" className="">{v.si_name}</span>
                            </div>
                            <div className="">
                                <label style={{width:'85px'}}>휴대폰 번호</label>
                                <span name="si_tel" type="text" className="">{phoneFormat(v.si_tel)}</span>
                            </div>
                            <div className="" style={{position:'relative'}}>
                                <label style={{width:'85px'}}>주소</label>
                                <span type="text" className="">{v.si_address}</span>
                            </div>
                        </div>
                    )
                }

            
                
          </div>

          <div className="row mb-4 p-0" style={{ borderBottom: '2px solid black' }}>
            <h3 className="font-weight-bold mb-3">금액정보</h3>
          </div>
          <div className="row p-0">
            <div className="col-4 pl-0">
              <span className="font-weight-bold d-block r_s_size">상품 총액</span>
            </div>
            <div className="col-8">
              <div className="mb-3 text-right">
                <span className="font-weight-bold" id="service_price">
                  {totalPrice(data)}원
                            </span>
              </div>
            </div>
          </div>
          <hr className="r_mg_top_none" />
          <div className="row r_mbdown p-0">
            <div className="col-3 pl-0">
              <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
            </div>
            <div className="col-9">
              <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice">{totalPrice(data)}원</div>
            </div>

          </div>
          <div className="row mb-2 p-0">
                <div className="col-12 text-center pl-0" onClick={() => history.goBack()}>
                    <div className="pt-3 pb-3 btn btn-outline-secondary w-100">돌아가기</div>
                </div>
          </div>
          
        </div>
        
      </Container>
      
      <Bottom_menu />

        </>
    )
}

export default OrderPage;